var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.159,
    height: 2200.925,
    viewBox: "0 0 9.159 2200.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.159,
    height: 2200.925,
    transform: "translate(63.581 11.252)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.74,
    height: 2259.501,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.741,
    height: 2259.501,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.581 -11.252)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 8.198,
    transform: "translate(68.534 2251.303)",
    fill: "none",
    stroke: "#001233",
    strokeLinejoin: "bevel",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    y1: 24.686,
    transform: "translate(68.534 2210.158)",
    fill: "none",
    stroke: "#001233",
    strokeLinejoin: "bevel",
    strokeWidth: 8,
    strokeDasharray: "6.023 6.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.991,2192.356V148.183c0-113.269,0-144.643-.006-146.808",
    transform: "translate(32.542 9.571)",
    fill: "none",
    stroke: "#001233",
    strokeLinejoin: "bevel",
    strokeWidth: 8,
    strokeDasharray: "6.023 6.023 6.023 6.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.175,4.017Q1.613,3.988.02,4.008",
    transform: "translate(0.001 6.93)",
    fill: "none",
    stroke: "#001233",
    strokeLinejoin: "bevel",
    strokeWidth: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.6142aa4aa223276293da3eba12e4cf40.svg";
export { ForwardRef as ReactComponent };